export const ACCESS_TOKEN = 'access-token'
export const REFRESH_TOKEN = 'refresh-token'

/** Matches backend JWT access token lifetime (15m). */
export const ACCESS_TOKEN_MAX_AGE = 15 * 60

/** Matches backend JWT refresh token lifetime (7d). */
export const REFRESH_TOKEN_MAX_AGE = 7 * 24 * 60 * 60

export const TELEGRAM_CHANNEL_URL = 'https://t.me/nekrashenko_ai'
export const X_PROFILE_URL = 'https://x.com/Alexalexlex8855'
